import { motion } from 'framer-motion';

interface AIAvatarProps {
  isAISpeaking: boolean;
  persona: {
    profile: {
      name: string;
      age: number;
      occupation: string;
      avatarUrl: string;
    };
  };
}

export function AIAvatar({ isAISpeaking, persona }: AIAvatarProps) {
  if (!persona?.profile) return null;

  return (
    <div className="relative flex flex-col items-center">
      <div className="relative">
        <div className="relative inline-block">
          <img
            alt={`${persona.profile.name}'s Avatar`}
            src={persona.profile.avatarUrl}
            className="h-24 w-24 lg:h-40 lg:w-40 rounded-full object-cover border-2 lg:border-4 border-white shadow-md"
          />
          {/* Age indicator */}
          <div className="absolute -bottom-1 -right-1 bg-primary text-white text-[10px] lg:text-xs font-bold rounded-full w-5 h-5 lg:w-6 lg:h-6 flex items-center justify-center shadow-sm">
            {persona.profile.age}
          </div>
          {isAISpeaking && <SpeakingAnimation />}
        </div>
      </div>
    </div>
  );
}

function SpeakingAnimation() {
  return (
    <div className="absolute inset-0">
      <motion.div
        className="absolute inset-0 border-4 border-primary rounded-full"
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.7, 0.3, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="absolute inset-0 border-4 border-primary rounded-full"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.7, 0.3, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.5,
        }}
      />
    </div>
  );
}
